<div>
  <label>
    {{ label }}
  </label>
  <input
    [disabled]="isDisabled"
    [ngModel]="dateTime"
    class="date-time-picker-input"
    [ngClass]="hasError ? 'error' : 'valid'"
    type="datetime-local"
    [max]="max"
    [min]="min"
    (ngModelChange)="onDateTimeChange($event)"
  />
</div>
